import EmploymentTypeTable from "./EmploymentTypeTable";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import useEmploymentType from "./hooks/useEmploymentType";
import useDeleteEmploymentType from "./hooks/useDeleteEmploymentType";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import React, { Fragment, useState, useCallback } from "react";
import { useQueryClient } from "react-query";
import EmploymentTypeForm from "./EmploymentTypeForm";

const EmploymentType = () => {
  const viewPermission = PERMISSIONS.permission_utilities_employeetype_employmenttype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <EmploymentTypeTable /> : ""}</>
  );
};

export default EmploymentType;
